import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './storeConfiguration';

import rootReducer from './reducers/index.js';

import DraftsList from './containers/DraftsList.jsx';

function setDraftsReact() {
    let store = configureStore(rootReducer);
    ReactDOM.render(
    <Provider store={store}>
        <DraftsList />
    </Provider>,
    document.getElementById('root-drafts'));
}

function init() {
    if (document.getElementById('root-drafts') !== null) {
        setDraftsReact();
    }
}

export { init }




// WEBPACK FOOTER //
// ./src/_app/drafts/drafts.js